var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"subHeader"},[_c('div',{staticClass:"sh-center"},[_c('CategorySlider')],1),_c('div',{staticClass:"sh-right"},[_c('q-btn',{staticClass:"full-width",attrs:{"to":{ name: 'DiscountDetail' },"unelevated":"","no-caps":"","flat":""}},[_vm._v("\n      Discounts & Offers\n    ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }